export default "__VITE_ASSET__BO2RAKZo__"